import { render, staticRenderFns } from "./getUserid.vue?vue&type=template&id=ff21ade6"
import script from "./getUserid.vue?vue&type=script&lang=js"
export * from "./getUserid.vue?vue&type=script&lang=js"
import style0 from "./getUserid.vue?vue&type=style&index=0&id=ff21ade6&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports